import { http } from './http'
// 下载
export const getPluginUrl = () => {

  return http({
    // baseUrl: baseUrl,
    url: "/api/public/latest-version",
    method: "get",
    alert: false,
    // query: params,
  });
};
